module.exports = __webpack_public_path__ + "static/media/service1.8b26f57d.jpg";